<script lang="ts">
    import { getModalStore, getToastStore } from "@skeletonlabs/skeleton";

    const modalStore = getModalStore();
    const toastStore = getToastStore();

    let new_title = "";

    // Updates the application data in rfp_applications with the provided parameters and returns a toast afterwards
    async function update_value(event: Event): Promise<void> {
        event.target!.disabled = true;
        await fetch("/api/drafts/create", {
            method: "POST",
            body: JSON.stringify({
                title: new_title ? new_title : undefined,
            }),
        })
            .then((resp) => {
                if (resp.ok) {
                    resp.json().then((res) => {
                        toastStore.trigger({
                            message: "✓ " + res.message,
                            background: "bg-zinc-800 text-green-300 text-center",
                            timeout: 4000,
                        });
                    });

                    $modalStore[0].response({}); // without this the callback function in modal settings will not trigger
                    modalStore.clear();
                } else {
                    resp.json()
                        .then((res) => {
                            toastStore.trigger({
                                message: "✗ " + res.message,
                                background: "bg-zinc-800 text-red-400 text-center",
                                timeout: 8000,
                            });
                        })
                        .catch(() => {
                            toastStore.trigger({
                                message:
                                    "✗ Something went wrong. Please try again or contact us if this error persists.",
                                background: "bg-zinc-800 text-red-400 text-center",
                                timeout: 8000,
                            });
                        });
                }
            })
            .finally(() => {
                event.target.disabled = false;
            });
    }
</script>

<div class="p-8 bg-white rounded-lg">
    <h1 class="text-xl font-bold">Create Application</h1>
    <input
        type="text"
        bind:value={new_title}
        class="input rounded-lg border border-[solid] border-stone-200 mt-3"
        placeholder="Title"
    />
    <button
        class="bg-zinc-800 text-white hover:shadow-md px-4 py-2 rounded-lg mt-3 disabled:bg-secondary-600 transition duration-300"
        on:click={(e) => {
            update_value(e);
        }}
    >
        Submit
    </button>
</div>
